(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /**
     * Used to lazy load <video> elements by adding "vide-lazy-load" css class.
     * 
     * Primarily used to lazy load videos for "carbon_cloudinary_video" shortcode.
     * 
     * @see includes/cloudinary_video.php
     */
    (function(){
        const videosElems = document.querySelectorAll('.video-lazy-load');
        if (!videosElems.length) return;
        // element must have a visibility threshold of 50%
        const lazyLoadObserver = new IntersectionObserver(function(entries, observer){
            entries.forEach(function(entry){
                if (!entry.isIntersecting) return;
                let videoElem = entry.target;
                videoElem.querySelectorAll('source[data-src]').forEach(function(sourceElem){
                    sourceElem.src = sourceElem.dataset.src;
                });
                videoElem.load();
                lazyLoadObserver.unobserve(videoElem);
            });
        }, {threshold: 0.5});
        videosElems.forEach(function(videoElem){
            lazyLoadObserver.observe(videoElem);
        });
    })();

}));
